import styled from 'styled-components'

import { Warnings } from '../Warnings'

export const WrappedWarnings = styled(Warnings)`
  margin-bottom: 0;
`
